export const interactiveSessionPermissions = {
  CallVisitReasons: {
    Write: "callVisitReasonsCanWrite"
  }
};
